"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLinkPreview = exports.parseMessage = exports.parseAttachment = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const utilities_1 = require("../helper/utilities");
const parseAttachment = (json) => {
    if (!json || !json.image_urls)
        return undefined;
    return {
        imageUrls: {
            original: json.image_urls.original,
            squareMedium: json.image_urls.square_medium,
            squareSmall: json.image_urls.square_small,
            wideMedium: json.image_urls.wide_medium,
        },
    };
};
exports.parseAttachment = parseAttachment;
const parseMessage = (json) => {
    if (!json)
        return undefined;
    return {
        attachments: json.attachments
            .map(exports.parseAttachment)
            .filter(utilities_1.isNotNullOrUndefined),
        author: {
            gid: json.author.gid,
            id: json.author.identifier,
            type: json.author.type,
        },
        body: json.body,
        conversation: {
            gid: json.conversation.gid,
            id: json.conversation.identifier,
        },
        createdAt: new Date(json.created_at),
        id: json.identifier,
        linkPreviewUrl: json.link_preview_url,
    };
};
exports.parseMessage = parseMessage;
const parseLinkPreview = (json) => {
    if (!json)
        return undefined;
    return {
        description: json.description,
        image_urls: {
            square_small: json.image_urls.square_small,
            wide_medium: json.image_urls.wide_medium,
        },
        originalUrl: json.original_url,
        title: json.title,
        url: json.url,
    };
};
exports.parseLinkPreview = parseLinkPreview;
